import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";
import {
  IAPI_RET017_Request,
  IAPI_RET017_Response,
} from "../../../type/apiType";

// 受領者変更参照
const httpAPI_RET017 = async (
  param: IAPI_RET017_Request
): Promise<IAPI_RET017_Response> => {
  let res = await http.post(ApiUrl.API_RET017, {
    ...param,
  });
  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_RET017, httpAPI_APP016 };
